<template>

    <v-row class="d-flex justify-space-between mb-2 mt-2">
      <v-col cols="12" md="3" v-if="props.isClubManager" >
        <v-btn color="success" @click="showRegistration = true">{{ $t('club.club_members.add_representant') }}</v-btn>
      </v-col>
      <v-col cols="12" md="2" v-if="props.isClubManager">
        <v-btn color="primary" @click="copyEmails">{{ $t('club.club_members.copy_emails') }}</v-btn>
      </v-col>
      <v-col cols="12" md="2" v-if="props.isChairman">
        <v-btn color="primary" @click="submitChanges">{{ $t('club.club_members.save_permissions') }}</v-btn>
      </v-col>
    </v-row>

    <!-- Dialog egistrace člena -->
    <v-dialog v-model="showRegistration" max-width="900px">
      <v-card>
        <ClubPageRepreRegistration
          :club="props.club"
          @registered="onRegistered"
          @close="showRegistration = false"
        />
      </v-card> 
    </v-dialog>



    <template v-for="section in displaySections" :key="section.categoryKey">
      <h2 class="mt-6">{{ section.categoryLabel }}</h2>

      <v-row class="mt-1">
        <v-col
          v-for="group in section.lvlGroups"
          :key="`${section.categoryKey}-${group.lvl}`"
          cols="12"
          :md="isClubManager ? 12 : 4"
        >
        <h3 v-if="section.type === 'age'" class="font-italic">{{ group.label }}</h3>

        <v-data-table
        :headers="memberHeaders"
        :items="group.items"
        density="compact"
        :items-per-page="-1"
        hide-default-footer
        :loading="loading"
        loading-text="general.loading"
        width="100%"
        no-data-text="club.club_members.empty_class"
        :sort-by="sortBy"
        striped="even"
        hover

      >
        <template v-slot:[`item.last_name`]="{ item }">
          <v-tooltip
            location="top center"
            origin="auto"
            :text="$t('general.last_activity') + ': ' + $formatDateTime(item.last_activity)"
          >
            <template #activator="{ props }">
              <router-link
                v-bind="props"
                :to="`/ucet/${item.id}`"
                style="white-space: nowrap;"
              >
                {{ item.last_name }} {{ item.first_name }}
              </router-link>
            </template>
          </v-tooltip>
        </template>

        <template v-if="isClubManager" v-slot:[`item.email`]="{ item }">
          {{ item.email }}
        </template>
        <template v-if="isClubManager" v-slot:[`item.si_number`]="{ item }">
          {{ item.si_number }}
        </template>

        <template v-if="section.type === 'staff'" v-slot:[`item.description`]="{ item }">
          {{ item.description }}
        </template>
        <!-- <template v-else v-slot:[`item.description`]="{ item }">
        </template> -->
        <template v-if="isClubManager" 
          v-slot:[`item.organizer`]="{ item }">
          <v-checkbox density="compact" v-model="item.is_organizer" hide-details :disabled="!isChairman"></v-checkbox>
        </template>

        <template
          v-if="isClubManager"
          v-slot:[`item.club_manager`]="{ item }"
        >
          <v-checkbox
            v-model="item.is_club_manager"
            :disabled="item.id === Number(authStore.userID) || !isChairman"
            density="compact"
            hide-details
          />
        </template>

        <template
          v-if="isClubManager"
          v-slot:[`item.actions`]="{ item }"
        >
          <v-list-item-action>
            <v-icon
              @click="openEditDialog(item)"
              color="blue"
              size="x-large"
              class="mr-2"
              :title="$t('club.club_members.edit_member')"
            >mdi-pencil</v-icon>
            <v-icon
              @click="openRemoveDialog(item)"
              v-if="item.id !== Number(authStore.userID) && isChairman"
              color="warning"
              size="x-large"
              class="mr-2"
              :title="$t('club.club_members.remove_from_club')"
            >mdi-account-remove</v-icon>
          </v-list-item-action>
        </template>

      </v-data-table>
        </v-col>
      </v-row>
    </template>

    <!-- Dialog pro editaci Account -->
    <v-dialog v-model="dialogEditAccount" persistent max-width="600px">
    <v-card>
        <v-card-title>
            {{ selectedAccount.last_name }} {{ selectedAccount.first_name }} ({{ selectedAccount.index }})
        </v-card-title>
        <v-card-text>

            <v-row>
            <v-col cols="12">
                <v-select v-model="selectedAccount.lvl" :items="lvlOptions" :label="$t('club.club_members.choose_class')" :rules="[rules.lvl]" density="comfortable" />
            </v-col>
            <!-- <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.last_name" label="Příjmení" required :rules="[rules.last_name]"></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.first_name" label="Křestní jméno" required :rules="[rules.firstName]"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
                <CountrySelect v-model="selectedAccount.country" label="Země" />
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.email" label="Email" :rules="[rules.isValidEmail]" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field v-model="selectedAccount.si_number" type="number" label="Číslo čipu" :rules="[rules.siNumber]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-autocomplete
                v-model="selectedAccount.assist_user"
                :items="assistUser.filter(u => u.id !== selectedAccount.id)"
                label="Správce tohoto účtu"
                item-value="id"
                item-title="fullName"
                clearable
                multiple
                chips
                closable-chips
                no-data-text="Uživatel není v databázi"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="selectedAccount.birth_year" label="Rok narození" type="number" :rules="[rules.year]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-select v-model="selectedAccount.gender" :items="sexOptions" label="Pohlaví" :rules="[rules.gender]"></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="selectedAccount.index" label="Index" required :rules="[rules.index]"></v-text-field>
            </v-col> -->
            </v-row>

            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogEditAccount = false">{{ $t('general.cancel') }}</v-btn>
            <v-btn color="green darken-1" text @click="editAccount" :disabled="!isFormValid">{{ $t('general.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>



    <!-- Dialog pro potvrzení smazání člena oddílu -->
    <v-dialog v-model="dialogRemoveAccount" persistent max-width="600px">
        <v-card>
            <v-card-title class="text-h5">{{ $t('club.club_members.remove_title') }}</v-card-title>
            <v-card-text>
              <i18n-t keypath="club.club_members.remove_text_repre">
                <strong>{{ selectedAccount.first_name }} {{ selectedAccount.last_name }}</strong>
              </i18n-t>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogRemoveAccount = false">{{ $t('general.cancel') }}</v-btn>
            <v-btn color="warning darken-1" text @click="removeAccount">{{ $t('club.club_members.remove_btn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>




  <ScrollTopButton />

</template>


<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';
import { useI18n } from 'vue-i18n'

import ScrollTopButton from '@/components/shared/ScrollTopButton.vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import ClubPageRepreRegistration from './ClubPageMembersTableRepreRegistration.vue';

const snackbar = useSnackbarStore()
const authStore = useAuthStore();
const { t } = useI18n();

const props = defineProps({
    members: Array,
    club: Object,
    assistUser: Array,
    isClubManager: Boolean,
    isChairman: Boolean,    
    loading: Boolean,
  });


const emit = defineEmits(['fetchMembers']);

// const { isLoggedIn } = storeToRefs(useAuthStore());
const route = useRoute();
const clubShortcut = computed(() => route.params.id);


const lvlOptions = [
  { title: t('club.club_members.class_1'), value: '1' },
  { title: t('club.club_members.class_2'), value: '2' },
  { title: t('club.club_members.class_3'), value: '3' },
  { title: t('club.club_members.class_4'), value: '' },
]

// pevné pořadí a popisky "kádru" (bez realizačního týmu — ten je samostatná sekce)
const athleteLvlBuckets = ['1', '2', '3']
const lvlLabels = {
  '1': t('club.club_members.class_1') + ' ' + t('club.club_members.class'),
  '2': t('club.club_members.class_2') + ' ' + t('club.club_members.class'),
  '3': t('club.club_members.class_3'),
  '': t('club.club_members.class_4'),
}

const clubKind = computed(() => {
  const sc = (clubShortcut.value || props.club?.club_shortcut || '').toUpperCase()
  const typ = (props.club?.club_type || '').toUpperCase()
  if (sc === 'SCM' || typ === 'SCM') return 'SCM'
  if (sc === 'REP' || typ === 'REPRE') return 'REP'
  return null
})

/** Rok narození ze 4 číslic indexu (např. RCZ1051 → 2010, RCZ2651 → 2026). */
function birthYearFromIndex(index) {
  const match = String(index || '').match(/(\d{4})$/)
  if (!match) return null
  const yy = parseInt(match[1].substring(0, 2), 10)
  if (Number.isNaN(yy)) return null
  const currentYear = new Date().getFullYear()
  let birthYear = 2000 + yy
  if (birthYear > currentYear) birthYear = 1900 + yy
  return birthYear
}

function memberAge(member) {
  const year = member.birth_year || birthYearFromIndex(member.index)
  if (!year) return null
  return new Date().getFullYear() - Number(year)
}

function isFemaleMember(member) {
  return String(member.gender || '').toUpperCase() === 'F'
}

function assignAgeCategory(member, kind) {
  const age = memberAge(member)
  const female = isFemaleMember(member)
  if (age == null) return 'UNKNOWN'

  if (kind === 'REP') {
    if (age <= 19) return female ? 'D19' : 'M19'
    return female ? 'D20' : 'M20'
  }

  if (kind === 'SCM') {
    if (age > 16) return 'OVER'
    if (age <= 14) return female ? 'D14' : 'M14'
    return female ? 'D16' : 'M16'
  }

  return 'UNKNOWN'
}

const categoryLabels = computed(() => ({
  D19: t('club.club_members.category_d19'),
  M19: t('club.club_members.category_m19'),
  D20: t('club.club_members.category_d20'),
  M20: t('club.club_members.category_m20'),
  D14: t('club.club_members.category_d14'),
  M14: t('club.club_members.category_m14'),
  D16: t('club.club_members.category_d16'),
  M16: t('club.club_members.category_m16'),
  OVER: t('club.club_members.category_scm_over_age'),
  UNKNOWN: t('club.club_members.category_unknown'),
}))

const categoryOrderByClub = {
  REP: ['D19', 'M19', 'D20', 'M20', 'UNKNOWN'],
  SCM: ['D14', 'M14', 'D16', 'M16', 'OVER', 'UNKNOWN'],
}

const displaySections = computed(() => {
  const kind = clubKind.value
  const labels = categoryLabels.value
  const realization = (props.members || []).filter((m) => m.lvl === '')
  const athletes = (props.members || []).filter((m) => m.lvl !== '')

  const sections = []

  if (kind) {
    const order = categoryOrderByClub[kind]
    for (const catKey of order) {
      const inCat = athletes.filter((m) => assignAgeCategory(m, kind) === catKey)
      if (!inCat.length) continue

      const lvlGroups = athleteLvlBuckets
        .map((lvl) => ({
          lvl,
          label: lvlLabels[lvl],
          items: inCat.filter((m) => m.lvl === lvl),
        }))
        .filter((g) => g.items.length)

      if (lvlGroups.length) {
        sections.push({
          type: 'age',
          categoryKey: catKey,
          categoryLabel: labels[catKey] || catKey,
          lvlGroups,
        })
      }
    }
  } else {
    athleteLvlBuckets.forEach((lvl) => {
      const items = athletes.filter((m) => m.lvl === lvl)
      if (!items.length) return
      sections.push({
        type: 'age',
        categoryKey: `lvl-${lvl}`,
        categoryLabel: lvlLabels[lvl],
        lvlGroups: [{ lvl, label: lvlLabels[lvl], items }],
      })
    })
  }

  if (realization.length) {
    sections.push({
      type: 'staff',
      categoryKey: 'staff',
      categoryLabel: lvlLabels[''],
      lvlGroups: [{ lvl: '', label: lvlLabels[''], items: realization }],
    })
  }

  return sections
})

const sortBy = [{ key: 'birth_year', order: 'asc' }]; // Klíč pro řazení

// společné hlavičky pro všechny tabulky, podle oprávnění
const memberHeaders = computed(() => {
  const headers = [
    { title: t('club.club_members.headers.name'), value: 'last_name', sortable: true, align: 'start' },
    { title: t('club.club_members.headers.index'), value: 'index', sortable: true, align: 'start' },
  ];

  if (props.isClubManager) {
    headers.push(
      { title: t('club.club_members.headers.email'), value: 'email', sortable: false },
      { title: t('club.club_members.headers.si_number'), value: 'si_number', sortable: false },
      { title: t('club.club_members.headers.birth_year'), value: 'birth_year', sortable: true, align: 'start' },
    );
  }

  if (props.isClubManager) {
    headers.push(
      { title: t('club.club_members.headers.organizer'), value: 'organizer', sortable: false },
      { title: t('club.club_members.headers.club_manager'), value: 'club_manager', sortable: false },
      { title: t('club.club_members.headers.actions'), value: 'actions', sortable: false, width: '120' },
    );
  }

  // description sloupec vždy – data uvidíte jen v realizačním týmu
  // headers.push({ title: 'Popis', value: 'description', sortable: false });

  return headers;
});

// Aktualizace seznamu členů po registraci nového
const showRegistration = ref(false); // Zobrazit dialog pro registraci člena

function onRegistered() {
  showRegistration.value = false;
  // obnov seznam členů
  emit('fetchMembers');
}

const dialogEditAccount = ref(false);
const openEditDialog = (account) => {
  selectedAccount.value = { ...account }
  dialogEditAccount.value = true;
};

const selectedAccount = ref({
  last_name: '',
  first_name: '',
  email: '',
  si_number: null,
  birth_year: null,
  gender: '',
  index: '',
  assist_user: [],
  country: '',
  lvl: '',
});

const dialogRemoveAccount = ref(false);
const openRemoveDialog = (account) => {
  selectedAccount.value = account;
  dialogRemoveAccount.value = true;
};




const rules = {
  
  // isValidEmail: value => (/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) || 'Neplatný email',
  // year: value => (value && value >= 1920 && value <= new Date().getFullYear()) || 'Neplatný rok.',
  // siNumber: value => !value || /^\d{4,7}$/.test(value) || 'Číslo SI musí mít 4 až 7 cifer.',
  // index: value => (/^[A-Za-z]{3}\d{4}$/.test(value)) || 'Neplatný index',
  // firstName: value => (value.trim() !== '') || 'Jméno je povinné pole.',
  // last_name: value => (value.trim() !== '') || 'Příjmení je povinné pole.',
  // gender: value => (['M', 'F'].includes(value)) || 'Pohlaví je povinné pole.',
  lvl: v => ['1','2','3',''].includes(v) || t('club.club_members.choose_class'),


};

// validace pro disable tlačítka uložit v edit account
const isFormValid = computed(() => {
  return rules.lvl(selectedAccount.value.lvl) === true;
    // rules.isValidEmail(selectedAccount.value.email) === true &&
    // rules.year(selectedAccount.value.birth_year) === true &&
    // rules.siNumber(selectedAccount.value.si_number) === true &&
    // rules.index(selectedAccount.value.index) === true &&
    // rules.firstName(selectedAccount.value.first_name) === true &&
    // rules.last_name(selectedAccount.value.last_name) === true &&
    // rules.gender(selectedAccount.value.gender) === true;
});






const copyEmails = async () => {
   // Filtrování členů, kteří mají email a neobsahují "rob-is.cz"
   const emails = props.members
    .filter(member => member.email && !member.email.includes('rob-is.cz'))  // Filtrovat jen členy, kteří mají email a email neobsahuje "rob-is.cz"
    .map(member => member.email)     // Získat emaily
    .join(', ');                     // Spojit emaily do jednoho řetězce odděleného čárkou

  try {
    // Zkopírování emailů do schránky
    await navigator.clipboard.writeText(emails);
    snackbar.success(t('club.club_members.emails_copied'));
  } catch (err) {
    console.error('Chyba při kopírování emailů:', err);
  }
};


const submitChanges = async () => {
  // Tvorba seznamu aktualizovaných členů pro odeslání
   const updatedMembers = props.members.map(member => ({
    role_id: member.role_id,
    is_organizer: !!member.is_organizer,
    is_club_manager: !!member.is_club_manager
  }));

  // Kontrolní log výsledného seznamu pro ověření
  console.log('Updating member roles:', JSON.stringify(updatedMembers));

  // Odesílání dat na server
  try {
    const response = await apiClient.post(`members/?club_shortcut=${clubShortcut.value}`, updatedMembers);
    if (response.status === 200) {
      snackbar.success(t('club.club_members.permissions_updated'));
      authStore.updateRoles(response.data.user_permissions); // uložení rolí uživatele do pinia auth sotre
      emit("fetchMembers");
    } else {
      throw new Error('Failed to update member roles');
    }
  } catch (error) {
    console.error('Error updating member roles:', error);
  }
};



const editAccount = async () => {
  try {
    // Vytvoření jednoduchého objektu z reaktivního selectedAccount
    const accountData = {
      id: selectedAccount.value.id,
      // first_name: selectedAccount.value.first_name,
      // last_name: selectedAccount.value.last_name,
      // email: selectedAccount.value.email,
      // si_number: selectedAccount.value.si_number,
      // birth_year: selectedAccount.value.birth_year,
      // gender: selectedAccount.value.gender,
      // index: selectedAccount.value.index,
      // assist_user: selectedAccount.value.assist_user,
      // country: selectedAccount.value.country,
      lvl: selectedAccount.value.lvl,
    };
    if (accountData.lvl === '0') {
      accountData.lvl = ''; // Pokud je úroveň 0, nastavíme ji na prázdnou hodnotu
    }
    
    const response = await apiClient.put(`/members/?role_id=${selectedAccount.value.role_id}`, accountData);
    if (response.status === 200) {
      snackbar.success(t('club.club_members.account_updated'));
      emit("fetchMembers"); // Aktualizace seznamu členů po úspěšném uložení
      dialogEditAccount.value = false;
      }
    } catch (error) {
    if (error.response && error.response.status === 409) {
      snackbar.error(error.response.data.error);
    } else {
      snackbar.error(t('club.club_members.update_failed') + ': ' + error.message);
    }
    console.error('Error updating account:', error);
  }
};



const removeAccount = async () => {
  try {
    const response = await apiClient.post(`members/?remove_index=${selectedAccount.value.index}`);
    if (response.status === 200) {
      snackbar.success(t('club.club_members.account_removed_repre'));
      emit("fetchMembers"); // Obnovit seznam členů po úspěšném vyřazení
    } else {
      throw new Error('Failed to delete account');
    }
  } catch (error) {
    console.error('Error deleting account:', error);
  } finally {
    dialogRemoveAccount.value = false;
  }
};





</script>

<style scoped>



</style>
